module.exports = __webpack_public_path__ + "img/parrallel_4.fedf765f.png";